// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"7aecb040","453":"ae8e5deb"}[chunkId] + ".chunk.js";
};